import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations.js'
Vue.use(Vuex)
//创建对象
const store=new Vuex.Store({
	// 保存状态
	state:{
		usermesg:{}
	},
	mutations:mutations,
	// 执行异步
	actions:{
		
	},
	getters:{
		
	},
	modules:{
		
	}
})
//导出store对象
export default store


// WEBPACK FOOTER //
// ./src/store/index.js